import { getDefaultStore } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const DISMISSED_VERSION_KEY = 'app_update_dismissed_version';

export const dismissedUpdateVersionAtom = atomWithStorage<string | null>(
  DISMISSED_VERSION_KEY,
  null,
  createJSONStorage<string | null>(() => window.sessionStorage),
);

export function isDismissedUpdateVersionSync(version: string) {
  return getDefaultStore().get(dismissedUpdateVersionAtom) === version;
}

export function dismissUpdateVersion(version: string) {
  getDefaultStore().set(dismissedUpdateVersionAtom, version);
}
